<template>
    <v-dialog
        v-model="dialogForm"
        scrollable
        persistent
        content-class="dialog-ecommerce br-15"
    >
        <v-card>
            <v-toolbar
                elevation="0"
                dark
                class="primary-degrade white--text fix-flex"
            >
                <v-toolbar-title>
                    {{ message }} - Etapa ({{ etapa }} de 4)
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    fab
                    width="24px"
                    height="24px"
                    elevation="0"
                    color="#fff"
                    @click="fecharDialogo()"
                >
                    <v-icon size="18px" color="primary">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-stepper v-model="etapa" non-linear class="elevation-0 card-body">
                <v-stepper-header class="px-2">
                    <v-stepper-step
                        editable
                        :rules="regra.etapa1"
                        error-icon="mdi-alert-circle"
                        step="1"
                    >
                        Cadastro de acordo
                    </v-stepper-step>
                    <v-divider class="mx-2" />
                    <v-stepper-step
                        editable
                        :rules="regra.etapa2"
                        error-icon="mdi-alert-circle"
                        step="2"
                    >
                        Seleção de Filiais
                    </v-stepper-step>
                    <v-divider class="mx-2" />
                    <v-stepper-step
                        editable
                        :rules="regra.etapa3"
                        error-icon="mdi-alert-circle"
                        step="3"
                    >
                        Seleção de Produtos
                    </v-stepper-step>
                    <v-divider class="mx-2" />
                    <v-stepper-step editable step="4">
                        Efetivação do acordo
                    </v-stepper-step>
                </v-stepper-header>

                <div class="etapas-conteudo">
                    <v-stepper-items class="min-h-100">
                        <v-stepper-content step="1">
                            <Cadastro
                                ref="cadastro"
                                v-model="acordo"
                                :usuarioTipo="usuarioTipo"
                                @limpaFiliais="$refs.filial.limpaSelecionadas()"
                            ></Cadastro>
                        </v-stepper-content>
                        <v-stepper-content class="min-h-100" step="2">
                            <Filial
                                ref="filial"
                                v-model="acordo"
                            ></Filial>
                        </v-stepper-content>
                        <v-stepper-content step="3" class="min-h-100">
                            <Produto ref="produto" v-model="acordo"></Produto>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <Efetivacao ref="efetivacao" v-model="acordo" />
                        </v-stepper-content>
                    </v-stepper-items>
                </div>
                <div class="d-flex card-footer pa-4">
                    <v-btn
                        color="yellow"
                        width="130px"
                        class="new-button"
                        dark
                        @click="voltar"
                        :disabled="carregando"
                    >
                        <v-icon left>mdi-chevron-left-circle</v-icon>
                        Voltar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        width="130px"
                        class="new-button"
                        :disabled="carregando"
                        @click="proximo"
                        v-if="!acordo.fnLeitura || etapa < 4"
                    >
                        {{ botao }}
                        <v-icon right>{{ botaoIco }}</v-icon>
                    </v-btn>
                </div>
            </v-stepper>
        </v-card>

        <v-overlay z-index="500" :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-dialog>
</template>

<script>
import Cadastro from "./Cadastro.vue";
import Efetivacao from "./Efetivacao.vue";
import Produto from "./Produto.vue";
import Filial from "./Filial.vue";

export default {
    name: "formularioAcordoGC",
    inject: ["listaCampos"],
    components: {
        Cadastro,
        Efetivacao,
        Produto,
        Filial,
    },
    data() {
        return {
            etapa: 1,
            lista: [],
            message: "Criação de acordo GC",
            dialogForm: false,
            carregando: false,
            acordo: {
                periodo: [],
                clustersNoAcordo: [],
            },
            usuarioTipo: "rd",
            botao: "Avançar",
            botaoIco: "mdi-chevron-right-circle",
            regra: {
                etapa1: [
                    () => {
                        if (this.etapa > 1) {
                            return this.$refs.cadastro.validate();
                        }
                        return true;
                    },
                ],
                etapa2: [
                    () => {
                        if (this.etapa > 2) {
                            return this.$refs.filial.validate();
                        }
                        return true;
                    },
                ],
                etapa3: [
                    () => {
                        if (this.etapa > 3) {
                            return this.$refs.produto.validate();
                        }
                        return true;
                    },
                ],
            },
        };
    },
    async provide() {
        return {
            listaCampos: await this.listaCampos,
        };
    },
    async created() {
        var lista = await this.listaCampos;
        this.lista.cluster = lista.cluster;
    },
    watch: {
        etapa(valor) {
            if (valor == 1) {
                this.botao = "Avançar";
                this.botaoIco = "mdi-chevron-right-circle";
            } else if (valor == 2) {
                this.botao = "Avançar";
                this.botaoIco = "mdi-chevron-right-circle";
                this.carregaFilial();
            } else if (valor == 3) {
                this.botao = "Avançar";
                this.botaoIco = "mdi-chevron-right-circle";
            } else if (valor == 4) {
                this.botao = "Salvar";
                this.botaoIco = "mdi-check-circle";
                this.resumoAcordo();
            }
        },
    },
    methods: {
        async carregaFilial() {
            await this.$refs.filial.setAcordo();
        },
        filiaisEscolhidas() {
            const periodo = this.$refs.filial.getPeriodo();
            return this.$refs.filial.dados.filter((item) => {
                return periodo.some((p) => item[p]);
            });
        },
        resumoAcordo() {
            const resumo = {
                filiais: this.filiaisEscolhidas().length,
                produtos: this.$refs.produto.produtoSalvo.length,
            };
            this.$refs.efetivacao.setResumo(resumo);
        },
        getPeriodo(campo = "quantidade") {
            let extraido = [];
            for (var i of this.acordo.periodo) {
                extraido.push(
                    campo +
                    "_" +
                    i.substring(0, 4) +
                    "_" +
                    parseInt(i.substring(5, 7))
                );
            }
            return extraido;
        },
        async salvarAcordo() {
            if (this.carregando) return;

            if (
                !this.$refs.cadastro.validate() ||
                !this.$refs.filial.validate() ||
                !this.$refs.efetivacao.validate() ||
                !this.$refs.produto.validate()
            ) {
                return this.$dialog.notify.error("Formulário com erros", {
                    position: "top-right",
                    timeout: 5000,
                });
            }

            this.carregando = true;

            const data = this.$helpers.cloneObj(this.acordo);
            const periodo = this.getPeriodo();

            data.filiais = this.$refs.filial.dados
                .filter((item) => periodo.some((p) => item[p]))
                .map((a) => {
                    let obj = {
                        id_filial: a.id_filial,
                        id_java: a.id_java,
                        id_bandeira: a.id_bandeira,
                    };
                    for (const e of periodo) {
                        obj[e] = a[e];
                    }
                    return { ...obj };
                });

            data.produto = this.$refs.produto.produtoSalvo.map((a) => ({
                id_produto: a.id_produto,
                vb_pdv: a.vb_pdv,
                pdv: a.pdv,
            }));

            const formData = new FormData();
            formData.append("data", JSON.stringify(data));

            if (this.acordo.planograma instanceof File) {
                formData.append("files", this.acordo.planograma);
            }

            try {
                let response;
                if (data.fnEditar) {
                    response = await this.$http().post(
                        "/acordoGC/editar",
                        formData
                    );
                } else {
                    response = await this.$http().post(
                        "/acordoGC/salvar",
                        formData
                    );
                }

                if (response.data.success) {
                    this.$dialog.notify.success(response.data.msg, {
                        position: "top-right",
                        timeout: 5000,
                    });
                    this.dialogForm = false;
                    this.$emit("filtrar");
                } else {
                    this.$dialog.notify.error(
                        response.data?.msg || "Erro ao salvar acordo GC",
                        { position: "top-right", timeout: 5000 }
                    );
                }
            } catch (error) {

                this.$dialog.notify.success("Erro ao salvar acordo GC", {
                    position: "top-right",
                    timeout: 5000,
                });
                this.dialogForm = false;
                this.$emit("filtrar");
            }

            this.carregando = false;
        },
        proximo() {
            if (this.etapa == 4) {
                return this.salvarAcordo();
            } else {
                this.etapa++;
            }
        },
        voltar() {
            if (this.etapa > 1) {
                this.etapa--;
            }
        },
        fecharDialogo() {
            this.etapa = 1;
            this.dialogForm = false;
        },
        novo(usuarioTipo) {
            this.usuarioTipo = usuarioTipo;
            this.dialogForm = true;
            this.etapa = 1;
            try {
                this.$refs.cadastro.limpaCadastro();
                this.$refs.cadastro.resetValidation();
                this.$refs.filial.limpaFiltro();
                this.$refs.filial.limpaSelecionadas();
                this.$refs.produto.limpaProdutos();
                this.$refs.produto.reset();
            } catch (error) {
                error;
            }
            this.message = "Criação de acordo GC";
            this.carregando = false;
            this.acordo = {
                fnReplicar: false,
                periodo: [],
                projeto: null,
                produtos: [],
                categorias: [],
                clustersNoAcordo: [],
            };
            try {
                this.$refs.cadastro.resetValidation();
            } catch (error) {
                error;
            }
        },
        async editar(item, fnLeitura = false) {
            this.dialogForm = true;
            if (fnLeitura) {
                this.message = `Exibir Acordo GC (${item.id_acordo_gc})`;
            } else {
                this.message = `Editar Acordo GC (${item.id_acordo_gc})`;
            }
            this.carregando = true;

            var data = {
                id_acordo_gc: item.id_acordo_gc,
            };

            try {
                this.$refs.cadastro.limpaCadastro();
                this.$refs.cadastro.resetValidation();
                this.$refs.filial.limpaFiltro();
                this.$refs.filial.limpaSelecionadas();
                this.$refs.produto.limpaProdutos();
            } catch (error) {
                //console.log(error)
            }

            try {
                const response = await this.$http().post("/acordoGC/acordo", {
                    data: data,
                });

                const result = response.data.result || response.data;

                // Converter mes (ISO date) para array de periodo (YYYY-MM)
                const periodo = [];
                if (result.mes) {
                    periodo.push(this.$moment(result.mes).format("YYYY-MM"));
                }

                this.etapa = 1;
                this.acordo = {
                    fnReplicar: false,
                    fnEditar: true,
                    fnLeitura: fnLeitura,
                    id_acordo_gc: result.id_acordo_gc || item.id_acordo_gc,
                    id_contrato_gc: result.id_contrato_gc,
                    periodo: periodo,
                    produtos: result.produtos || [],
                    obs_departamento: result.obs_departamento,
                    obs_contrato: result.obs_contrato,
                    comentario: result.comentario,
                    categoria_produto: result.categoria_produto,
                    projeto: result.projeto,
                    id_espaco_gc: result.id_espaco_gc,
                    categorias: result.categorias || (result.categoria ? [result.categoria] : []),
                    id_bandeira: result.id_bandeira,
                    clustersNoAcordo: result.clusters || [],
                    visivel: result.visivel,
                    planogramaUrl: result.planograma || null,
                    filiaisAcordo: result.filiais || [],
                };

                await new Promise((resolve) => setTimeout(resolve, 100));
                await this.carregaFilial();
                await this.$refs.produto.reset();

                const produtosAcordo = (result.produtos || []).map((p) => ({
                    ...p,
                    pdv: true,
                    vb_pdv: p.vb || "",
                }));

                this.$refs.produto.setProdutos(produtosAcordo);
                this.$refs.produto.produtoSalvo = produtosAcordo.map((p) => ({ ...p }));
            } catch (error) {
                this.$dialog.notify.error("Erro ao carregar acordo GC", {
                    position: "top-right",
                    timeout: 5000,
                });
                this.dialogForm = false;
                this.$emit("filtrar");
            }

            this.carregando = false;
        },
    },
};
</script>

<style>
.etapas-conteudo {
    height: 100%;
    overflow: auto;
}
.card-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}
.card-footer {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15) !important;
}
.fix-flex {
    flex-grow: 0;
    flex-shrink: 1;
}
</style>

<style lang="scss">
.dialog-ecommerce {
    height: 100%;
    max-height: calc(100% - 50px) !important;
    .v-stepper__header {
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15) !important;
    }
    .v-stepper__content {
        box-shadow: unset !important;
    }
    .v-stepper__step {
        padding: 10px;
        margin: 15px;
        background-color: #f5f5f5;
        border-radius: 8px;
        min-width: 200px;
        justify-content: center;
        .v-stepper__label {
            color: #000 !important;
            font-weight: 500;
            font-size: 0.9rem;
        }
        .v-stepper__step__step {
            background-color: var(--v-primary-base) !important;
            height: 20px;
            width: 20px;
            min-width: 20px;
        }
        &:hover .v-stepper__label {
            text-shadow: unset !important;
        }
        &.v-stepper__step--error {
            .v-stepper__label {
                color: red !important;
            }
            .v-stepper__step__step {
                background-color: #fff !important;
                .v-icon {
                    color: red;
                    font-size: 24px;
                }
            }
        }
        &.v-stepper__step--active {
            background-color: var(--v-primary-base);
            color: white;
            &:hover {
                background-color: var(--v-primary-base);
            }
            .v-stepper__label {
                color: #fff !important;
            }
            .v-stepper__step__step {
                background-color: #fff !important;
                color: var(--v-primary-base) !important;
            }
        }
    }
}
</style>
